import React, { useState, useEffect } from "react";
import { Route, Routes, Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../providers/AuthContext.jsx";
import { isEmpty } from "../helpers/functions.js";
import { GAMES_CATEGORY_NAV, ADMIN_NAV } from "./APP_ROUTES.jsx";
import GamesCategoryHeader from "../pages/User/Games/GamesCategoryHeader.jsx";
import { SearchGames } from "../pages/User/Games/SearchGames.jsx";
import HeroBanner from "../pages/User/Games/HeroBanner.jsx";
import Login from "../pages/Auth/LoginPage.jsx";
import Betting from "../pages/User/Betting/index.jsx";
import DashboardLayout from "../pages/Admin/DashboardLayout.jsx";
import AppHeader from "../components/layout/header/AppHeader.jsx";
import Footer from "../components/layout/Footer.jsx";
import GamePlay from "../pages/User/Games/GamePlay.js";
import PromotionsPage from "../pages/User/promotions/index.js";
import UserMyAccount from "../pages/User/AccountSetting/UserMyAccount.jsx";
import AccountSettings from "../pages/User/AccountSetting/index.jsx";
import UserDeposit from "../pages/User/AccountSetting/UserDeposit.jsx";
import UserChangePassword from "../pages/User/AccountSetting/UserChangePassword.jsx";
import UserTransactionsHistory from "../pages/User/AccountSetting/UserTransactionHistory.jsx";
import UserCasinoBets from "../pages/User/AccountSetting/UserCasinoBets.jsx";
import UserWithdraw from "../pages/User/AccountSetting/UserWithdraw.jsx";

function AppRoutes() {
  const location = useLocation();
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const [isSearchModalOpen, setIsSearchModalOpen] = useState(false);

  const [isTablet, setIsTablet] = useState(window?.innerWidth <= 1024);
  const [isMobile, setIsMobile] = useState(window?.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsTablet(window.innerWidth <= 1024);
      setIsMobile(window.innerWidth <= 480);
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const { user, logout } = useAuth();
  const isAuthenticated = !!user;
  const isUserRole = user?.role === "User";

  const handleLoginClick = () => setIsLoginModalOpen(true);
  const handleSearchModal = () => setIsSearchModalOpen(true);

  const handleLoginSuccess = () => {
    setIsLoginModalOpen(false);
  };

  const adminNav = ADMIN_NAV();

  // Determine if the Header should be displayed
  const isExcludedRoute = adminNav.some(({ path }) => location.pathname === "/admin" + "" + path);
  const gamesCtaegoryNav = GAMES_CATEGORY_NAV();
  const excludeGameCategoryHeader = gamesCtaegoryNav.some(({ path }) => location.pathname === path);

  return (
    <div className="bg-body text-white min-h-screen overflow-x-hidden">
      {/* Main Navigation (Always Visible) */}
      {!isExcludedRoute && (
        <AppHeader
          user={user}
          excludeGameCategoryHeader={excludeGameCategoryHeader}
          onLoginClick={handleLoginClick}
          onRegisterClick={handleLoginClick}
          onLogout={logout}
        />
      )}

      {isSearchModalOpen && (
        // <Modal
        //   isOpen={isSearchModalOpen}
        //   onClose={() => setIsSearchModalOpen(false)}
        //   className="w-full lg:max-w-[60rem] lg:h-[calc(100vh-80px)] h-screen"
        //   title={<h2 className="mt-[20px] font-bold md:text-xl text-lg">Search Engine</h2>}
        // >
        <SearchGames isOpen={isSearchModalOpen} onClose={() => setIsSearchModalOpen(false)} />
        // </Modal>
      )}

      {/* Conditionally Games Categories Navigation (Header) */}
      {excludeGameCategoryHeader && !location.pathname.startsWith("/livecasino") ? (
        <div className="px-3">
          <HeroBanner />
          <GamesCategoryHeader openSearchModal={handleSearchModal} />
        </div>
      ) : null}

      {/* Routes */}
      <Routes>
        {/* Public Landing Page */}
        {/* <Route path="/" element={<LandingPage />} /> */}
        <Route path="/game-play/:id" element={<GamePlay />} />
        <Route path="/live-games/:id" element={<GamePlay />} />
        <Route path="/spaceman/:id" element={<GamePlay />} />
        <Route path="/promotions" element={<PromotionsPage />} />
        {/* Game Page and Subroutes */}
        <Route path="/login" element={<Login />} />
        {(user && user.role === "User") || isEmpty(user) ? (
          <>
            <Route index path="/sportsbook/sports" element={<Betting />} />
            <Route path="/sportsbook/live" element={<Betting />} />
            <Route path="/virtuals" element={<Betting />} />
          </>
        ) : null}
        {gamesCtaegoryNav.map((item) => (
          <Route key={item.label} path={item.path} element={item.component} />
        ))}
        {/* Redirect Based on User Role */}
        <Route
          path="/user"
          element={
            isAuthenticated ? (
              isUserRole ? (
                <Navigate to="/sportsbook/sports" replace />
              ) : (
                <Navigate to="/admin/transfer" replace />
              )
            ) : (
              <Navigate to="/sportsbook/sports" replace />
            )
          }
        />
        {isUserRole && (
          <Route path="/user/*" element={<AccountSettings />}>
            {/* <Route index /> */}
            <Route index path="my-account" element={<UserMyAccount />} />
            <Route path="deposit" element={<UserDeposit />} />
            <Route path="withdraw" element={<UserWithdraw />} />
            <Route path="sports-bets" element={<Betting />} />
            <Route path="change-password" element={<UserChangePassword />} />
            <Route path="transaction-history" element={<UserTransactionsHistory />} />
            <Route path="casino-history" element={<UserCasinoBets />} />
            {/* <Route path="verify-account" element={<UserVerifyAccount />} /> */}
          </Route>
        )}
        {/* Protected Routes for Admin/Other Roles */}
        <Route
          path="/sportsbook/sports"
          element={<Navigate to={isAuthenticated ? (isUserRole ? "/sportsbook/sports" : "/admin/transfer") : "/sportsbook/sports"} replace />}
        />
        {/* <Route path="/game-history" element={<GameHistory />} /> */}
        <Route element={<DashboardLayout excludeGameCategoryHeader={excludeGameCategoryHeader} user={user} logout={logout} />}>
          {adminNav.map((item) => (
            <Route
              key={item.label}
              path={"/admin" + "" + item.path}
              element={isAuthenticated && !isUserRole ? item.component : <Navigate to="/sportsbook/sports" replace />}
            />
          ))}
        </Route>
        {/* Fallback Route */}
        <Route path="*" element={<Navigate to="/sportsbook/sports" replace />} />
      </Routes>
      {isLoginModalOpen && <Login onLoginSuccess={handleLoginSuccess} isOpen={isLoginModalOpen} setIsOpen={setIsLoginModalOpen} />}
      <Footer />
    </div>
  );
}

export default AppRoutes;
